export default __webpack_public_path__ + "static/char-09-anr-f8d6f5ce272e0ed6978e4c25a158d73d.gif";